import a from '@/utils/axios/axios'

const game = {
  namespaced: true,
  state: () => ({
    game_players: {
      home: [],
      away: []
    },
    saving_players: false,
    stadium: {
      name: null,
      external_resource_id: null,
      id: null
    },
    referee: {
      name: null,
      external_resource_id: null,
      found: false
    },
    loading_game_stadion: false,
    loading_game_players: false,
    loading_game_referee: false
    // {
    //   "num": 1,
    //   "pos": "2K",
    //   "picture_url": "https://www.pesistulokset.fi/storage/pelaajakuvat/8097cde963fed16863c15d600079a35b-maxWidth125.png",
    //   "external_service_id": 9082,
    //   "player_name": "Mikko Vihriälä",
    //   "league_game_id": "84e5f21f-5d13-471f-81af-4228334badf3",
    //   "league_id": 6,
    //   "league_club_id": 24
    // }
  }),
  mutations: {
    SET_REFEREE(state, val) {
      state.referee = val
    },
    SET_SAVING_PLAYERS(state, val) {
      state.saving_players = val
    },
    ADD_PLAYER(state, { side, player }) {
      const mod = { ...state.game_players }
      mod[side] = mod[side].concat(player)
      state.game_players = mod
    },
    SET_LINEUPS(state, val) {
      state.lineups = val
    },
    SET_STADIUM(state, val) {
      state.stadium = val
    },
    SET_SIDE_PLAYERS(state, { side, players }) {
      const mod = { ...state.game_players }
      mod[side] = players
      state.game_players = mod
    },
    SET_GAME_PLAYERS(state, val) {
      state.game_players = val
    },
    UPDATE_STADIUM_FOUND(state) {
      let st = state.stadium
      st['found'] = true
      state.stadium = st
    },
    UPDATE_PLAYER_FOUND(state, { name, found, side }) {
      let mod = state.game_players[side]
      const player = mod.find(p => p.player_name == name)
      const index = mod.findIndex(p => p.player_name == name)
      if (index !== -1) {
        const newSide = [
          ...mod.slice(0, index),
          { ...player, found },
          ...mod.slice(index + 1)
        ]
        const otherSide = state.game_players[side !== 'home' ? 'home' : 'away']
        state.game_players = {
          home: side === 'home' ? newSide : otherSide,
          away: side === 'away' ? newSide : otherSide
        }
      }
    },
    SET_LOADING_GAME_STADION(state, val) {
      state.loading_game_stadion = val
    },
    SET_LOADING_GAME_PLAYERS(state, val) {
      state.loading_game_players = val
    },
    SET_LOADING_GAME_REFEREE(state, val) {
      state.loading_game_referee = val
    },
    SET_HITTER_SIDE(state, { player_id, hits_from_left, side }) {
      let mod = state.game_players

      const index = mod[side].findIndex(p => p.id === player_id)
      mod[side][index].hits_from_left = hits_from_left

      state.game_players = mod
    },
    SET_EVENTS(state, val) {
      state.events = val
    },
    SET_LOADING_EVENTS(state, val) {
      state.loading_events = val
    }
  },
  actions: {
    getGameEvents({ commit }, league_game_id) {
      alert('getGameEvents')
      return new Promise((resolve, reject) => {
        commit('SET_LOADING_EVENTS', true)
        a.get(`/filter2/game/${league_game_id}/events`)
          .then(e => {
            commit('SET_EVENTS', e.data)
            resolve(e.data)
          })
          .catch(err => reject(err))
          .finally(() => commit('SET_LOADING_EVENTS', false))
      })
    },
    changeSideOrder({ commit, getters }, { side, players, number_follows_player }) {
      if(number_follows_player) {
        commit('SET_SIDE_PLAYERS', { side, players })
        return
      }

      players = players.map((player, i) => {
        return {
          ...player,
          num: getters.game_players[side][i].num
        }
      })

      commit('SET_SIDE_PLAYERS', { side, players })
    },
    addEmpty({ commit }, { side, league_club_id, league_id, league_game_id }) {
      commit('ADD_PLAYER', {
        side,
        player: {
          num: '',
          pos: '',
          player_name: '',
          league_club_id,
          league_id,
          league_game_id
        }
      })
    },
    removePlayer({ commit, getters }, { side, index }) {
      const new_arr = getters.game_players[side].filter((_, i) => i !== index)
      commit('SET_SIDE_PLAYERS', { side, players: new_arr })
    },
    setHitterSide({ commit }, { player_id, hits_from_left, side }) {
      return new Promise((resolve, reject) => {
        a.patch(`/league/player/${player_id}`, { hits_from_left })
          .then(e => {
            commit('SET_HITTER_SIDE', { player_id, hits_from_left, side })
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    savePlayers({ getters, commit }, { league_id, league_game_id }) {
      commit('SET_SAVING_PLAYERS', true)
      return new Promise((resolve, reject) => {
        a.post(`/league/${league_id}/game/${league_game_id}/game-player/batch`, { game_players: getters.game_players_concatenated })
          .then(e => {
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
          .finally(() => {
            commit('SET_SAVING_PLAYERS', false)
          })
      })
    },
    saveStadium({ getters }, { league_id, league_game_id }) {
      return new Promise((resolve, reject) => {
        a.post(`/league/${league_id}/game/${league_game_id}/game-stadion`, getters.stadium)
          .then(e => {
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    saveReferee({ getters }, { league_id, league_game_id }) {
      return new Promise((resolve, reject) => {
        a.post(`/league/${league_id}/game/${league_game_id}/game-referee`, getters.referee)
          .then(e => {
            resolve(e.data)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    initGamePlayers({ commit }, { league_game_id, home_club_id }) {
      commit('SET_LOADING_GAME_PLAYERS', true)
      a(`/league/game/${league_game_id}/game-player`)
        .then(e => {
          const gp = {
            home: e.data.filter(p => p.league_club_id === home_club_id).sort((a, b) => a.num - b.num).map(p =>{ return { ...p, found: true} }),
            away: e.data.filter(p => p.league_club_id !== home_club_id).sort((a, b) => a.num - b.num).map(p =>{ return { ...p, found: true} })
          }

          commit('SET_GAME_PLAYERS', gp)
        })
        .finally(() => {
          commit('SET_LOADING_GAME_PLAYERS', false)
        })

      commit('SET_LOADING_GAME_STADION', true)

      a(`/league/game/${league_game_id}/game-stadion`)
        .then(e => {
          commit('SET_STADIUM', { ...e.data, found: true })
        })
        .finally(() => {
          commit('SET_LOADING_GAME_STADION', false)
        })

      commit('SET_LOADING_GAME_REFEREE', true)
      a(`/league/game/${league_game_id}/game-referee`)
        .then(e => {
          commit('SET_REFEREE', { ...e.data, found: true })
        })
        .finally(() => {
          commit('SET_LOADING_GAME_REFEREE', false)
        })
    },
    checkPlayerExists({ commit }, { name, side, league_id }) {
      a(`/admin/player-check?player_name=${name}&league_id=${league_id}`)
        .then(e => {
          commit('UPDATE_PLAYER_FOUND', { name, found: e.data.found, side })
        })
        .catch(e => {
          console.log(e)
        })
    },
    checkStadiumExists({ commit, getters }, { name, league_id }) {
      console.log('in vuex', name, league_id)
      a.get(`/stadion/check-exists?name=${name}&league_id=${league_id}`)
        .then(() => {
          commit('SET_STADIUM', { ...getters.stadium, found: true })
        })
        .catch(() => {
          commit('SET_STADIUM', { ...getters.stadium, found: false })
        })
    },
    checkRefereeExists({ commit, getters }, { name, league_id }) {
      a(`/referee/check-exists?name=${name}&league_id=${league_id}`)
        .then(() => {
          commit('SET_REFEREE', { ...getters.referee, found: true })
        })
        .catch(() => {
          commit('SET_REFEREE', { ...getters.referee, found: false })
        })
    }
  },
  getters: {
    stadium: state => state.stadium,
    referee: state => state.referee,
    game_players: state => state.game_players,
    loading_game_players: state => state.loading_game_players,
    loading_game_stadion: state => state.loading_game_stadion,
    saving_players: state => state.saving_players,
    game_players_concatenated: state => {
      return state.game_players.home.concat(state.game_players.away)
    },
    players_by_club_id: state => id => {
      if(!id) return []
      return state.game_players.filter(p =>{
        return p.league_club_id === id
      })
    },
    loading_game_referee: state => state.loading_game_referee,
    events: state => state.events,
    loading_events: state => state.loading_events
  }
}

export default game